import { Chip, Stack, Typography } from '@mui/joy';
import { Warning } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import { UomValidationStatus } from 'bom/enums';
import { IUomTableRow } from 'bom/types';
import { Color, Level, Variant } from 'theme/enums';

export const UomStatusCell = ({ data, value, node }: ICellRendererParams<IUomTableRow, string>) => {
  // Group row: the auto group ("UOM Group") column reuses this renderer. When grouped by UOM, show
  // the group's UOM value (agGroupCellRenderer appends the count); grouped by another column there
  // is no UOM to show. Mirrors the is-grouped-by-column pattern in quotes/elements/*Cell.
  if (!data) {
    const isGroupedByUom = 'uom' === node?.rowGroupColumn?.getColId();

    return node?.group && isGroupedByUom ? value : null;
  }

  const isUnknown = data.uomValidationStatus === UomValidationStatus.UNKNOWN;

  return (
    <Stack gap={0.5} alignItems="flex-start">
      <Chip color={Color.DANGER} variant={Variant.SOFT} startDecorator={<Warning />}>
        {isUnknown ? t('labelUnknownUom') : t('labelUomMismatch')}
      </Chip>
      <Typography level={Level.BODY_SM}>{data.uom}</Typography>
    </Stack>
  );
};
